<template>
    <a-spin :spinning="spinning" tip="加载中...">
        <a-modal :visible="visible" :footer="null" width="300px" :maskClosable="false" @cancel="cancelModal" >  
        <div class="dqtitle">抖音App扫码授权</div> 
        <div class="dqtag"> 
            <p><img :src="qrcode" style="width: 250px;height: 250px;"></p>
        </div>
        </a-modal>
    </a-spin>
</template>

<script>
import { qcApi, requestHttp } from '@utils/index';
import { mapState } from 'vuex'; 
export default {
    name: 'awemeList',
    props: {
    },
    data() {
        return {
            qrcode:'',
            visible:false,
            spinning:false,
            dy_token:'',
            isget:false
        };
    }, 
    components: {}, 
    watch: {}, 
    computed: {
        ...mapState('User', ['wxInfo']),
        userName() {
            return this?.wxInfo?.nickname || '';
        },
        userId() {
            return this?.wxInfo?.id || '';
        },
    },
    mounted() {
        this.getQrcode();
    },
    methods: {
        async getQrcode(){
            this.spinning = true
            const { code, msg, data } = await requestHttp({
                api: `${qcApi.GET_KOL_ACCOUNT_LINK}`,
                method: 'POST',
                params: {
                    app: 'QDZS',
                    user_id:this.wxInfo.id, 
                },
            });
            this.spinning = false
            if (code == 0) {
                this.$message.error(msg);
                return;
            }
            this.qrcode = data.url
            this.dy_token = data.dy_token
            this.visible = true
            this.isget = true
            this.getStatus()
        },
        async getStatus(){
            try {
                const { code, msg, data } = await requestHttp({
                    api: `${qcApi.GET_KOL_ACCOUNT_LINK_STATUS}`,
                    method: 'POST',
                    params: {
                        app: 'QDZS',
                        state: this.wxInfo.id+'_QDZS_1',
                        dy_token: this.dy_token
                    },
                });
                if (code == 1) {
                    if (data.status == 2) {
                        this.isget = false
                        this.$message.success('授权成功');
                        //弹出授权成功提示
                        this.$emit('cancel'); 
                    }  
                    if(this.isget){
                        setTimeout(this.getStatus, 3000);
                    }
                }
            } catch {
                this.visible = false
            }
        },
        cancelModal(){
            this.isget = false
            this.$emit('cancel')
        }
    },
};
</script>

<style lang="less" scoped> 
.dqtitle{
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #1890ff;
  margin-bottom: 20px
}
.dqtag{
  font-size: 14px;
  color: #333;
  text-align: left;
  font-weight: bold;
}
.dqbtn{
  margin-top: 20px;
  button{
    margin-bottom: 10px;
    width:100%
  }
}
</style>